import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {toggleScroll} from "../lib/utils";
import styled from 'styled-components';

const StyledLayer = styled.div`
  z-index: 99999;
  height: ${props => props.visible ? "100vh" : 0};
  background: rgba(255, 255 , 255, .8);
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  overflow-x: hidden;
  pointer-events: ${props => props.visible ? "all" : "none"};
  opacity: ${props => props.visible ? "1" : "0"};
  -webkit-transition: opacity .2s ease-in-out;
  -moz-transition: opacity .2s ease-in-out;
  -o-transition: opacity .2s ease-in-out;
  transition: opacity .2s ease-in-out;
  & > div {
    pointer-events: ${props => props.visible ? "all" : "none"};
  }
`;

export default function Layer (props) {
  const {visible, toggleLayer, children} = props;
  const toggle = (e) => {
    const child = e.currentTarget.children[0];
    const minX = child.offsetLeft - child.offsetWidth/2;
    const maxX = child.offsetLeft + child.offsetWidth/2;
    const minY = child.offsetTop - child.offsetHeight/2;
    const maxY = child.offsetTop + child.offsetHeight/2;
    if(e.clientX < minX || e.clientX > maxX || e.clientY < minY || e.clientY > maxY){
      toggleLayer();
    }
  }

  useEffect(() => {
    toggleScroll(!visible);
  }, [visible]);

  return (
    <StyledLayer visible={visible} onClick={visible ? toggle : null}>
      {children}
    </StyledLayer>
  )
}

Layer.propTypes = {
  visible: PropTypes.bool,
  toggleLayer: PropTypes.func,
  children: PropTypes.any,
};
